export default __webpack_public_path__ + "static/media/plbgcircle4.1a736896.png";